module.exports = __webpack_public_path__ + "images/emoji/elephant.e854cf3812165eac4639.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/elephant.png
// module id = a9p7
// module chunks = 1